import api from '../config/api';

export interface MemberStats {
  total_likes: number;
  total_comments: number;
  total_score: number;
  likes_by_type: {
    expose: number;
    ramadan: number;
    event: number;
    audio: number;
    daara: number;
  };
  comments_by_type: {
    expose: number;
    ramadan: number;
    event: number;
    daara: number;
  };
}

export interface EngagedMember {
  user_id: number;
  first_name: string;
  last_name: string;
  username: string;
  email: string;
  section: string;
  photo: string | null;
  date_joined: string | null;
  last_activity: string | null;
  stats: MemberStats;
}

export interface SectionStats {
  total_members: number;
  total_likes: number;
  total_comments: number;
  total_score: number;
}

export interface EngagedMembersData {
  period: '7d' | '30d' | '90d' | 'all';
  summary: {
    total_members: number;
    total_likes: number;
    total_comments: number;
    total_score: number;
    average_score: number;
  };
  section_stats: Record<string, SectionStats>;
  members: EngagedMember[];
}

export interface MyEngagementStats {
  user_id: number;
  is_member: boolean;
  is_top_member: boolean;
  rank: number | null;
  total_members: number;
  stats: MemberStats | null;
  last_activity: string | null;
}

export const engagedMembersService = {
  getEngagedMembers: async (period: '7d' | '30d' | '90d' | 'all' = 'all'): Promise<EngagedMembersData> => {
    const response = await api.get('/engaged-members/', {
      params: { period }
    });
    return response.data;
  },
  getMyEngagementStats: async (): Promise<MyEngagementStats> => {
    const response = await api.get('/my-engagement-stats/');
    return response.data;
  },
};

